import { render } from "./project-set.vue?vue&type=template&id=0d74dbf0&scoped=true&ts=true"
import script from "./project-set.vue?vue&type=script&lang=ts"
export * from "./project-set.vue?vue&type=script&lang=ts"

import "./project-set.vue?vue&type=style&index=0&id=0d74dbf0&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d74dbf0"]])

export default __exports__